import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { ERROR_MESSAGES } from '../utils/config/modal-settings';


@Injectable()
export class ToastrInterceptor implements HttpInterceptor {
	constructor(public toasterService: ToastrService) {}
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			catchError((error: HttpErrorResponse) => {
				let msg;
				if(error.error.message !== undefined){
					msg = error.error.message;
				}else{
					msg = ERROR_MESSAGES[error.status] ? ERROR_MESSAGES[error.status] : ERROR_MESSAGES[0];
				}
				this.toasterService.error(msg, '', { extendedTimeOut: 3000 });
				return throwError(error);
			})
		);
	}
}
